"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pillShapes = void 0;
var _styledComponents = require("styled-components");
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var pillShapes = function pillShapes(_a) {
  var $shape = _a.$shape,
    $size = _a.$size;
  var styles;
  var shapeAndSize = $shape + "." + $size;
  switch (shapeAndSize) {
    case "round.small":
      styles = {
        height: "18px",
        borderRadius: "16px"
      };
      break;
    case "rectangle.small":
      styles = {
        height: "16px",
        borderRadius: "3px"
      };
      break;
    default:
      styles = {};
      break;
  }
  return (0, _styledComponents.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        ", "\n    "], ["\n        ", "\n    "])), styles);
};
exports.pillShapes = pillShapes;
var templateObject_1;